import { httpRequest } from "@/utils/HttpRequest";
import { IPage } from "@/types/ScmTypes";
import { IInquiryDetail, IInquirySearchFields, IInquiryChangeData, IInquiryInsert, IInquiryUpdate, IInquiryGoodsSearchField, IInquiryGoodsDetail } from "./inquiryTypes";

export interface ISCMPage<T, S> extends IPage<T> {
    statistics: S
}

class InquiryService {
    //列表
    async page(searchVo: IInquirySearchFields) {
        const apiUrl = "/sum/inquiry/findPage";
        return await httpRequest.post<IPage<IInquiryDetail>>(apiUrl, searchVo);
    }
    // 启禁用
    async change(changeVo: IInquiryChangeData) {
        const apiUrl = "/sum/inquiry/change";
        return await httpRequest.post<boolean>(apiUrl, changeVo);
    }
    // 新增
    async insert(insertVo: IInquiryInsert) {
        const apiUrl = "/sum/inquiry/insert";
        return await httpRequest.post<boolean>(apiUrl, insertVo);
    }
    //编辑
    async update(updateVo: IInquiryUpdate) {
        const apiUrl = "/sum/inquiry/update";
        return await httpRequest.post<boolean>(apiUrl, updateVo);
    }
     //单条
     async one(id: string) {
        const apiUrl = `/sum/inquiry/findById/${id}`;
        return await httpRequest.get<IInquiryDetail>(apiUrl);
    }
     // 导出模版
     async exportTemplate() {
        const apiUrl = `/sum/inquiry/downloadTpl`;
        return await httpRequest.getFile(apiUrl);
    }
     // 提交
     async inquiryChange(id: string) {
        const apiUrl = `/sum/inquiry/change/${id}`;
        return await httpRequest.get<boolean>(apiUrl);
    }


    //配件查询
    async materialPage(searchVo: IInquiryGoodsSearchField) {
        const apiUrl = "/sum/inquiry/material";
        return await httpRequest.post<IPage<IInquiryGoodsDetail>>(apiUrl, searchVo);
    }
  
}

export const inquiryService = new InquiryService();